import type { FaireProductEntity } from "../../entity_types/product";

export const p_5m6vq8pgp5: FaireProductEntity = {
  token: "p_5m6vq8pgp5",
  type: "product",
  name: "The Stockholm Scarf - 100% Recycled - Autumnal Falls - FW25",
  brandToken: "b_3mgp73jmn6",
  brandName: "Arctic Fox & Co. - North America",
  imageUrl:
    "https://cdn.faire.com/fastly/a1f1e391af25794bd5d706006376c9574a0525a79be643b01ec94b250d770f05.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4d8c9cd99268a27c2398142d46dc7ee07f51184094f203f030cdf6247a30de4.jpeg",
    "https://cdn.faire.com/fastly/26439e0da97f0c57a9c3704548221c869897572c15cc120b7a698e29a2ac2456.jpeg",
    "https://cdn.faire.com/fastly/b994560ad3383c0c0fb1dc994d9fc4f92af587b50781fb1fb31210ce58a785af.jpeg",
    "https://cdn.faire.com/fastly/69e97498fcc8e25e7299dfdfea408d41640c68e4da7889b730c00c3daaa6cdc2.jpeg",
    "https://cdn.faire.com/fastly/f68b9c0bdb27e1431b963199ae64f05d06f33ec8cac870b78f53e68e6f66389a.jpeg",
    "https://cdn.faire.com/fastly/19a93c88b09a70b2ba279f0ecd06d3f23d953f650a0238b7416ed2fb43f62dfe.jpeg",
    "https://cdn.faire.com/fastly/80071a0119683b5eecbfdeeca3356e8647abef6d5063b91d68f5d590d2bb982c.jpeg",
    "https://cdn.faire.com/fastly/6ef1ed2e78233cdde274aa06fcbb74672bdf5b07e4dc42c89ea32917a4cc40cf.jpeg",
  ],
  priceDollars: 17.58,
  description:
    "One of our best-selling styles. \nShowcasing the addictive super-soft brushed texture we’re known for, the Stockholm scarf is made from 100% recycled materials. \n\nUpdated this AW25/26 with fresh, on-trend new season shades that perfectly complement our timeless CORE best-selling check designs, named and inspired by nature’s beautiful ever-changing landscape from season to season.\n\nThe technical bits: \n\t•\tMade from 100% recycled materials (we are very proud to be one of the first brands using recycled acrylic achieved in collaboration with our supplier).\n\t•\tConstruction and brush cycles on the machines engineered to minimize any potential pilling. \n\t•\tBrushed an extensive six times compared to the industry standard of four, the result is a thicker, warmer, ‘fluffier’ texture. \n\nPlastic free packaging: arrives in our new 100% paper protective bags.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:46.519Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
